import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../core/api.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { UtilityService } from '../../../core/global/utility.service';
@Component({
  selector: 'app-user-add-model',
  templateUrl: './user-add-model.component.html',
  styleUrls: ['./user-add-model.component.sass']
})
export class UserAddModelComponent implements OnInit {
  public defaultUpdateId = '';
  addUserObj: any = {};
  orgList = []
  searchInput: any = '';
  sortedtby: any = 'id';
  page: number = 0; // Enter 1 if you want to use the server side pagination 
  p;
  updateId = '';
  orgName = [];
  gateList = [];
  gateName=[];
  remaining: number;
  error: number;
  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, private _adminService: ApiService, private _functions: FunctionsService, private _utility: UtilityService) { }

  ngOnInit(): void {
    this.updateId = window.localStorage.getItem('pushUserId');
    window.localStorage.removeItem('pushUserId');
    this.addUserObj.org_ref_id=''
    this.error=0
    if (this.updateId) {
      this.getUserDetails()
    }
    this.getOrg()
  }

  getOrg() {
    let data = { searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/org_list";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.orgList = response.data
      }
    })
  }
 async getUserCount(org_ref_id) {
    let data = { org_ref_id: org_ref_id };
    let url = "qr/user_count";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
     this.remaining=response.total-response.count
      }
    })
  }
  getUserDetails() {
    let wheredata = []
    wheredata = [{ 'field': '`qr_user`.`id`', 'value': this.updateId, 'type': 'WHERE', 'nested': '' }]
    let data = { whereData: wheredata, searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/user_list";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.addUserObj.user_name = response.data[0].user_name
        this.addUserObj.org_ref_id=response.data[0].org_ref_id
        this.addUserObj.value=response.data[0].is_allowed.toString()
        this.addUserObj.gate_names=response.data[0].assigned_gate_name
        this.onItemChange( this.addUserObj.value)
        this.onOrgChange( this.addUserObj.org_ref_id)

        let org_id = response.data[0].gate_ref_id.split(',')
        let lent = response.data[0].gate_ref_id.split(',').length;
        let org_ids = [];
        if (lent > 0) {
          for (let i = 0; i < lent; i++) {
            org_ids.push(parseInt(org_id[i]));
            this.onGateChange(org_ids.toString())
            if (i == (lent - 1)) {
              this.addUserObj.gate_ref_id = org_ids;
            }
          }
        }
      }
    })
  }
  async onOrgChange(event) {
    this.addUserObj.gate_ref_id=[]
   await this.getUserCount(event)
    let data={org_id:event}
    let url = "qr/gate_details";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
         this.gateList = response.data
      }
    })
  }
  onGateChange(event) {
    this.gateName = []
    for (let i = 0; i < this.gateList.length; i++) {
      for (let j = 0; j < event.length; j++) {
        if (this.gateList[i].id == event[j]) {
          this.gateName.push(this.gateList[i].gate_name)
        }
      }
    }
  }
  save() {
    if (this.gateName.length>0) {
      this.addUserObj.gate_names = this.gateName
    }
    if (this.remaining==0) {
      this.error++;
      this._utility.toastError("Number of Users Exceeds Maximum");
     }
   else if (!this.addUserObj.user_name) {
      this.error++;
      this._utility.toastWarning('Enter User Name');
    } else if (!this.addUserObj.org_ref_id) {
      this.error++;
      this._utility.toastWarning('Select Organization');
    }else if (!this.addUserObj.gate_ref_id) {
      this.error++;
      this._utility.toastWarning('Select Gate');
    }
    if (this.error == 0) {
      let url = 'qr/user_save';
      if (this.updateId != '') {
        this.addUserObj.updateId = this.updateId;
      }
      this._adminService.post(url, this.addUserObj).subscribe((response) => {
        if (response.success == true) {
          this._utility.toastSuccess(response.message);
          this.activeModal.close(true);
        } else {
          this._utility.toastError(response.message);
        }
      })
    }
  }
  onItemChange(value) {
    if (value == '1') {
      this.addUserObj.is_allowed = '1';
    }else{
      this.addUserObj.is_allowed = '0';
    }
  }
}
